import React from "react"; 
import axios from 'axios';
import Moment from 'moment';

import { Paper,Grid,Button, Stack, Typography,IconButton,TextField,Dialog,DialogTitle,DialogContent,DialogActions } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker,  LocalizationProvider } from '@mui/x-date-pickers';
// import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';
// import AdapterDateFns from '@mui/lab/AdapterDateFns'; 
// import {CalendarViewMonthOutlined} from '@mui/icons-material';  
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import {CalendarTodayOutlined as CalendarMonthIcon} from '@mui/icons-material';
import Page from '../../components/Page';
import LoaderContent from '../../components/Loader';  
// const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8;
// const MenuProps = {
//     PaperProps: {
//       style: {
//         maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//         width: 250,
//       },
//     },
//   };

// const section = {
//   height: '100%',
//   marginTop: 10, 
//   display:'flex', 
//   justifyContent:'center', 
//   alignItems:'center',  
//   width:'25%'
// };
import HTTPManager from "../../utils/httpRequestManager";

export default class Transactions extends React.Component {
    httpManager = new HTTPManager();
    constructor(props) {
        super(props);
    
        this.state={ 
            businessdetail:{}, 
            // dataManager: new DataManager(), 
            from_date:new Date(),
            to_date:new Date(),
            showDatePopup: false, 
            transactions:[],
            employeelist:[],
            selectedemps:[],
            type:'paid',
            transactiondetail:{},
            showDetail:false,
            isLoading: false,
        } 
        this.handlechangeFromDate = this.handlechangeFromDate.bind(this);
        this.handlechangeToDate = this.handlechangeToDate.bind(this);
        this.getTransactions = this.getTransactions.bind(this);
        this.getPrintHTML = this.getPrintHTML.bind(this)
        this.refundTransaction = this.refundTransaction.bind(this);
        this.voidTransaction = this.voidTransaction.bind(this);
    } 
    getPrintHTML(t){ 
        this.httpManager.postRequest(`pos/print/getTxnPrintHTML`,{id : t.id}).then(htmlres=>{
            
            if(htmlres.htmlMsg instanceof Array){
                htmlres.htmlMsg.forEach(html=>{ 
                    var final_printed_data = '<html><head><meta http-equiv="content-type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=0, minimum-scale=1.0, maximum-scale=1.0"></head><body>';
                    final_printed_data += "<div style='max-width:280px'>"+html+"</div>";
                    final_printed_data += '</body></html>';
                    if(htmlres.printers.printerIdentifier !== undefined){
                    // window.api.printHTML({html:html, printername:htmlres.printers.printerIdentifier}).then(r=>{//console.log(htmlres.printers.printerIdentifier)
                        window.api.printHTML({html:final_printed_data, printername:htmlres.printers.printerIdentifier}).then(r=>{//console.log(htmlres.printers.printerIdentifier)
                            //console.log("Printed Successfully.")
                        })
                    }
                    else{
                        this.setState({printerror: true})
                    }
                })
            }
            else{ 
                var final_printed_data = '<html><head><meta http-equiv="content-type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=0, minimum-scale=1.0, maximum-scale=1.0"></head><body>';
                final_printed_data += "<div style='max-width:270px'>"+htmlres.htmlMsg+"</div>";
                final_printed_data += '</body></html>';
                if(htmlres.printers.printerIdentifier !== undefined){
                    window.api.printHTML({html:final_printed_data , printername:htmlres.printers.printerIdentifier}).then(r=>{
                        //console.log("Printed Successfully.")
                    })
                }
                else{
                    this.setState({printerror: true})
                }
            }
        })
    }
    handlechangeFromDate(e){
        this.setState({from_date: e});
    }
    handlechangeToDate(e){
        this.setState({to_date: e});
    }
    handleClick(){
        // ////console.log(event.target)
            this.setState({anchorEl:null, openMenu:true, editForm:false, addForm:false});
    }
    getTransactions(){  
        this.setState({isLoading: true})
        let from_date = Moment(this.state.from_date).format('YYYY-MM-DD');
        let to_date = Moment(this.state.to_date).format('YYYY-MM-DD');
        // let url = config.root+"/report/transactions"
        var input = { 
            from_date: from_date,
            to_date: to_date
        }   

        this.httpManager.postRequest(`merchant/ticket/getTransactions`, input).then(res=>{
            //console.log(res.data)
            this.setState({transactions: res.data, isLoading: false, showDatePopup: false})
        })
      }
    handleClickInvent(opt){
        if(opt === 'inventory')
            this.setState({expand_menu_show : !this.state.expand_menu_show});
        if(opt === 'settings')
            this.setState({setting_menu_show : !this.state.setting_menu_show});
    } 
    componentDidMount(){ 

        let detail = window.localStorage.getItem("userdetail");
        this.setState({businessdetail: JSON.parse(detail)}, function(){ 
            var condition = navigator.onLine ?  true: false;
            this.setState({isOnline: condition}, function() {
                if(!this.state.isOnline) {
                    
                }
                else { 
                    this.getTransactions()
                }
            })
            
        });

    }
    getEmpDetails() {
        var userdetail = window.localStorage.getItem('userdetail');
        if(userdetail !== undefined && userdetail !== null){
            this.setState({isLoading: true})
            axios.get(`${process.env.REACT_APP_APIURL}/employee/`+JSON.parse(userdetail).businessId).then((res)=>{
                if(res.data.data.length>0) {
                    // this.getEmp(res.data.data[0])
                    var data = res.data.data 
                    var empids = data.map(r=>r.id);
                    this.setState({isLoading: false,employeelist:data,selectedemps: empids}, function(){
                        this.getTransactions()
                    })
                } 
                else{
                    this.getTransactions()
                }
            });
        }
    }
    getEmpName(empid){
        let emp = this.state.employeelist.filter(emp=>{return emp.id === Number(empid) })
        if(emp.length>0){
            return emp[0].firstName+" "+emp[0].lastName;
        }
        else{
            return ''
        }
    }
    checkEmp(empid){
        return this.state.selectedemps.indexOf(empid) > -1 ? true : false;
    }



    refundTransaction(txn){
        this.httpManager.postRequest(`/merchant/transaction/refund`, txn).then(r=>{
            //console.log(r.data);
            this.setState({transactiondetail:{}, showDetail: false})
            this.getTransactions();
        })
    }

    voidTransaction(txn){
        this.httpManager.postRequest(`/merchant/transaction/void`, txn).then(r=>{
            //console.log(r.data);
            this.setState({transactiondetail:{}, showDetail: false})
            this.getTransactions();
        })
    }
    
    render(){
        return(
            <Page title="Transactions | Astra POS">
                 {this.state.isLoading && <LoaderContent show={this.state.isLoading} />} 
                 <div>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                        Transactions
                        </Typography>
                        <IconButton onClick={()=>{
                            this.setState({showDatePopup: true})
                        }}><CalendarMonthIcon/></IconButton>
                    </Stack>
                    <Stack>
                        <Paper style={{ background: 'transparent',height: '90%'}}>
                            {this.state.type === 'paid' && <div style={{height: "100%"}}>
                            <Grid container spacing={3}  style={{height:'40px', background:'#f0f0f0', width:'100%', margin:'10px 0', padding: 0}}>
                                <Grid item xs={1} style={{height:'100%',width:'100%', margin:0, padding:'10px 20px', fontSize:'12px', fontWeight:'bold'}}> 
                                    Date
                                </Grid>
                                <Grid item xs={2} style={{height:'100%',width:'100%', margin:0, padding:10, fontSize:'12px', fontWeight:'bold'}}> 
                                    Ticket
                                </Grid>
                                {/* <Grid item xs={2} style={{height:'100%',width:'100%', margin:0, padding:10, fontSize:'12px', fontWeight:'bold'}}> 
                                    Transaction #
                                </Grid> */}
                                <Grid item xs={2} style={{height:'100%',width:'100%', margin:0, padding:10, fontSize:'12px', fontWeight:'bold'}}> 
                                    Transaction #
                                </Grid>
                                <Grid item xs={2} style={{height:'100%',width:'100%', margin:0, padding:10, fontSize:'12px', fontWeight:'bold'}}> 
                                    Total
                                </Grid>
                                <Grid item xs={2} style={{height:'100%',width:'100%', margin:0, padding:10, fontSize:'12px', fontWeight:'bold'}}> 
                                    Mode
                                </Grid>
                                <Grid item xs={1} style={{height:'100%',width:'100%', margin:0, padding:10, fontSize:'12px', fontWeight:'bold'}}> 
                                    Paid On
                                </Grid>
                                <Grid item xs={2} style={{height:'100%',width:'100%', margin:0, padding:'10px 20px', fontSize:'12px', fontWeight:'bold'}}> 
                                    Employee 
                                </Grid> 
                            </Grid>
                        <div style={{ width: '100%', height:  'calc(100% - 0px)',overflow: 'hidden', background: 'white'}}>
                    
                        <div style={{width: '100%', height: 'calc(100% - 0px)',paddingLeft: 0,paddingTop: 0,paddingBottom: 0,overflowY:'auto', overflowX:'hidden', 
                        boxSizing: 'content-box', background: 'white'}}>
                        {this.state.transactions.map(t=>{ 
                            // //console.log("transactions:",t)
                            return <Grid container spacing={3}  style={{height:'80px', cursor:'pointer', width:'100%', margin:0, padding: '10px 0',borderBottom:'1px solid #f0f0f0', background:(Number(t.ticketPayment)<0 ? 'rgba(255, 0 , 0 , 0.2)' : 'transparent')}} onClick={()=>{ 
                                this.setState({transactiondetail: t}, ()=>{
                                    this.setState({showDetail: true})
                                })
                            }}>
                            <Grid item xs={1} style={{height:'100%',width:'100%', margin:0, padding:'10px 20px', fontSize:'12px'}}> 
                                {Moment.parseZone(t.ticketDate).format("hh:mm:ss a")}<br/>
                                <span style={{color:'#999'}}>{Moment(t.ticketDate).format("MM/DD/YYYY")}</span>
                            </Grid>
                            <Grid item xs={2} style={{height:'100%',width:'100%', margin:0, padding:10, fontSize:'12px'}}> 
                                {t.ticket.ticketCode}
                                {t.ticket.ticketType === 'GiftCard' && <><br/>
                                <b>{t.ticket.ticketType}</b></>}
                            </Grid>
                            {/* <Grid item xs={2} style={{height:'100%',width:'100%', margin:0, padding:10, fontSize:'12px'}}> 
                                
                            </Grid> */}
                            <Grid item xs={2} style={{height:'100%',width:'100%', margin:0, padding:10, fontSize:'12px'}}> 
                                <b>#{t.transactionId}</b><br/>
                                <b style={{  color:Number(t.ticketPayment) > 0 ? '#909090' : 'rgba(255,0,0,0.7)', textTransform:'capitalize'}}>
                                    {(t.txnStatus === 'Voided' || t.txnStatus === 'Refunded') && t.ticketPayment>0  ? t.txnStatus:''}</b>
                            </Grid>
                            <Grid item xs={2} style={{height:'100%',width:'100%', margin:0, padding:10, fontSize:'12px'}}> 
                                <b>{Number(t.ticketPayment) > 0 ? "$ "+Number(t.ticketPayment).toFixed(2) : "($"+Math.abs(Number(t.ticketPayment)).toFixed(2)+")"}</b>
                            </Grid>
                            <Grid item xs={2} style={{height:'100%',width:'100%', margin:0, padding:10, fontSize:'12px', textTransform:'capitalize'}}> 
                                {/* {(t.payMode === 'Loyalty Points' || t.payMode === 'GiftCard') && <b>{t.payMode}</b>} */}
                                <b>{ t.payMode !== null && (t.payMode.toLowerCase() === 'cash' ? 'Cash' : ( t.payMode !== 'Loyalty Points' && t.payMode !== 'GiftCard'  && t.payMode !== 'Tips' ? t.paymentType+"("+t.cardType+")" : t.payMode))}</b>
                            </Grid>
                            <Grid item xs={1} style={{height:'100%',width:'100%', margin:0, padding:'10px 20px', fontSize:'12px'}}> 
                                {Moment(t.createdDate).format("hh:mm:ss a")}<br/>
                                <span style={{color:'#999'}}>{Moment.parseZone(t.createdDate).format("MM/DD/YYYY")}</span>
                            </Grid>
                            <Grid item xs={2} style={{height:'100%',width:'100%', display:'flex', flexWrap:'wrap', margin:0, padding:'10px 20px', fontSize:'12px', textTransform:'capitalize'}}> 
                                {/* {this.getEmpName(t.technician_id)} */}
                                {t.mEmployeeFirstName+" "+t.mEmployeeLastName}
                            </Grid>
 
                            
                        </Grid>
                        })}
                        </div></div>
                    
                    
                        {this.state.isLoading === false && this.state.transactions.length === 0 && <div>
                            <p style={{fontSize:'12px', width:'100%', textAlign:'center'}}>No transactions added yet.</p>
                        </div>}
                        </div>}
                        </Paper> 
                    </Stack>
                 </div>
                 <Dialog
                    className="custommodal"
                        open={this.state.showDatePopup}
                        onClose={()=>{
                            this.setState({showDatePopup: false, from_date: new Date(), to_date:new Date(), reporttype:'daily'})
                        }}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        style={{borderRadius:'10px'}}
                    >
                        <DialogTitle id="alert-dialog-title">
                            Select Date
                        </DialogTitle>
                        <DialogTitle title="Select Date" 
                        onClose={()=>{
                            this.setState({showDatePopup: false})
                        }}
                        />
                        <DialogContent> 
                            <Grid container>
                                
                                <Grid item xs={12} style={{padding:'20px'}}>
                                    <form autoComplete="off" noValidate> 
                                        <Stack direction={'column'}> 
                                            <div  style={{margin:'10px 0'}}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} fullWidth >
                                                <DesktopDatePicker
                                                    label="From"
                                                    inputFormat="MM/dd/yyyy"
                                                    maxDate={new Date()}
                                                    style={{marginRight:'10px'}}
                                                    value={this.state.from_date}
                                                    onChange={this.handlechangeFromDate}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                            </div>
                                            <div  style={{margin:'10px 0'}}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns} fullWidth 
                                                        style={{marginLeft:'10px'}}>
                                                    <DesktopDatePicker
                                                        label="To"
                                                        inputFormat="MM/dd/yyyy"
                                                        minDate={this.state.from_date}
                                                        maxDate={new Date()}
                                                        value={this.state.to_date} 
                                                        onChange={this.handlechangeToDate}
                                                        style={{marginLeft:'10px'}}
                                                        renderInput={(params) => <TextField {...params} />}
                                                    />
                                                </LocalizationProvider>    
                                            </div>
                                        </Stack>
                                    </form>  
                                </Grid> 
                            </Grid> 
                            </DialogContent>
                        <DialogActions style={{display:'flex', alignItems:'center', justifyContent:'center', marginBottom:'1rem'}}>
                            <Button variant="contained" onClick={()=>{ this.getTransactions()}} >Get Transactions</Button>
                        </DialogActions>
            </Dialog>
            <Dialog
                    className="txnDetailModal"
                        open={this.state.showDetail} 
                        onClose={()=>{
                            this.setState({showDetail: false, transactiondetail:{}})
                        }}
                        fullWidth
                        fullScreen
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        style={{borderRadius:'10px'}}
                    >
                        <DialogTitle id="alert-dialog-title">
                        {/* <ModalHeader title="" onClose={()=>{
                            this.setState({showDetail: false, transactiondetail:{}})
                        }} /> */}
                            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                                <h2>Transaction Details</h2>
                                <div>
                                    <Button variant="contained" onClick={()=>{
                                        this.setState({showDetail: false, transactiondetail:{}})
                                    }}>Close</Button>
                                </div>
                            </div>
                        </DialogTitle>
                        <DialogContent> 
                        
                                { (this.state.transactiondetail.txnStatus !== 'Voided' &&  this.state.transactiondetail.txnStatus !== 'Refunded') && this.state.transactiondetail.payMode !== 'Loyalty Points' && this.state.transactiondetail.payMode !== 'GiftCard'  && this.state.transactiondetail.payMode !== 'Tips' &&  <Grid container style={{display:'flex', flexDirection:'row', height:'100%'}}>

                                <Grid item xs={12} style={{position:'relative', bottom:0, left:0, right:0, borderTop:'1px solid #f0f0f0',display:'flex', flexDirection:'row', padding:10}}>

                            <Grid item xs={12} md={9} style={{borderRight:'2px solid #ccc', height:'100%'}}>
                                <Grid item xs={12} style={{height:'calc(100% - 10px)'}}>
                                   {this.state.transactiondetail.id !== undefined && <Grid item xs={12} style={{padding:'20px',display:'flex', flexDirection:'row'}}> 
                                        <Grid item xs={3} md={3}><b>Payment</b><br/>
                                        <b>#{this.state.transactiondetail.transactionId}</b></Grid>
                                        <Grid item xs={6} md={6}> 
                                            <Grid item xs={12} style={{height:'100%',width:'100%', margin:0, padding:'10px', fontSize:'12px'}}> 
                                                {Moment.parseZone(this.state.transactiondetail.createdDate).format("hh:mm:ss a MM/DD/YYYY")} <br/><br/>
                                               <b>Tender:</b> {this.state.transactiondetail.payMode.toLowerCase() === 'cash' ? this.state.transactiondetail.payMode : this.state.transactiondetail.card_type}<br/>
                                               <b>Ticket Code:</b> {this.state.transactiondetail.ticket.ticketCode}<br/>
                                               <b>Employee:</b> {this.state.transactiondetail.mEmployeeFirstName+" "+this.state.transactiondetail.mEmployeeLastName}<br/><br/>
                                               {this.state.transactiondetail.paymentNotes && <> <b>Notes:</b><br/> {this.state.transactiondetail.paymentNotes}</> }
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={3}  md={3}>
                                            <Grid item xs={12} style={{height:'100%',width:'100%', margin:0, padding:'10px', fontSize:'12px'}}> 
                                                <b>${Number(this.state.transactiondetail.ticketPayment).toFixed(2)}</b>
                                            </Grid> 
                                        </Grid>
                                    </Grid> }
                                    </Grid>

                                    <Grid item xs={12} style={{position:'relative', bottom:0, left:0, right:0, borderTop:'1px solid #f0f0f0',display:'flex', flexDirection:'row', padding:10}}>

                                    <Grid item xs={9} md={9}> <h3>Total</h3></Grid>
                                    <Grid item xs={3} md={3}> <h3>${Number(this.state.transactiondetail.ticketPayment).toFixed(2)}</h3></Grid>

                                    </Grid>
                                    </Grid>
                                    {/* <Grid item xs={3}>
                                    <Grid item xs={12} style={{display:'flex'}}>
                                            <Grid item xs={1}></Grid>
                                            <Grid item xs={10} style={{height:'100px'}}>
                                               {(this.state.transactiondetail.batchId !== '' &&this.state.transactiondetail.batchId !== null && this.state.transactiondetail.batchId !== undefined) && <Button onClick={()=>{
                                                    this.refundTransaction(Object.assign({},this.state.transactiondetail))
                                                }} style={{background:'rgba(255, 0 ,0,0.5)', color:'#8c0000', height:'100%',width:'100%', borderRadius:'0', border:'1px solid rgba(255, 0 ,0,0.5)'}}>Refund</Button>}


                                               {(this.state.transactiondetail.batchId === '' || this.state.transactiondetail.batchId === null || this.state.transactiondetail.batchId === undefined) && <Button onClick={()=>{
                                                    this.voidTransaction(Object.assign({},this.state.transactiondetail))
                                                }} style={{background:'rgba(255, 0 ,0,0.5)', color:'#8c0000', height:'100%',width:'100%', borderRadius:'0', border:'1px solid rgba(255, 0 ,0,0.5)'}}>Void Transaction</Button>}
                                            </Grid>
                                            <Grid item xs={1}></Grid>
                                            </Grid>
                                    </Grid> */}
                                    </Grid>
                                </Grid>}

                                {
                                    (this.state.transactiondetail.txnStatus === 'Voided' || this.state.transactiondetail.txnStatus === 'Refunded') && (this.state.transactiondetail.payMode !== 'Loyalty Points' || this.state.transactiondetail.payMode !== 'GiftCard'  || this.state.transactiondetail.payMode !== 'Tips') && <Grid container style={{display:'flex', flexDirection:'row', height:'100%'}}>

                                    <Grid item xs={12} style={{position:'relative', bottom:0, left:0, right:0, borderTop:'1px solid #f0f0f0',display:'flex', flexDirection:'column', padding:10}}>
                                        <Grid item xs={12} style={{height:'calc(100% - 10px)'}}>
                                       {this.state.transactiondetail.id !== undefined && <Grid item xs={12} style={{padding:'20px',display:'flex', flexDirection:'row'}}> 
                                            <Grid item xs={3} md={3}><b>Payment</b><br/>
                                            <b>#{this.state.transactiondetail.transactionId}</b>
                                            <br/><b style={{textTransform:'capitalize'}}>Voided</b>
                                            </Grid>
                                            <Grid item xs={6} md={6}> 
                                                <Grid item xs={12} style={{height:'100%',width:'100%', margin:0, padding:'10px', fontSize:'12px'}}> 
                                                    {Moment.parseZone(this.state.transactiondetail.createdDate).format("hh:mm:ss a MM/DD/YYYY")} <br/><br/>
                                                   <b>Tender:</b> {this.state.transactiondetail.payMode.toLowerCase() === 'cash' ? this.state.transactiondetail.payMode : this.state.transactiondetail.card_type}<br/>
                                                   <b>Ticket Code:</b> {this.state.transactiondetail.ticket.ticketCode}<br/>
                                                   <b>Employee:</b> {this.state.transactiondetail.mEmployeeFirstName+" "+this.state.transactiondetail.mEmployeeLastName}<br/><br/>
                                                   {this.state.transactiondetail.paymentNotes && <> <b>Notes:</b><br/> {this.state.transactiondetail.paymentNotes}</> }
                                                </Grid>
                                            </Grid>
    
                                            <Grid item xs={3}  md={3}>
                                                <Grid item xs={12} style={{height:'100%',width:'100%', margin:0, padding:'10px', fontSize:'12px'}}> 
                                                    <b>${Number(this.state.transactiondetail.ticketPayment).toFixed(2)}</b>
                                                </Grid> 
                                            </Grid>
                                        </Grid> }
                                        </Grid>
    
                                        <Grid item xs={12} style={{position:'relative', bottom:0, left:0, right:0, borderTop:'1px solid #f0f0f0',display:'flex', flexDirection:'row', padding:10}}>
    
                                        <Grid item xs={9} md={9}> <h3>Total</h3></Grid>
                                        <Grid item xs={3} md={3}> <h3>${Number(this.state.transactiondetail.ticketPayment).toFixed(2)}</h3></Grid>
    
                                        </Grid> 
                                        </Grid>
                                    </Grid>
                                }


                         
                            </DialogContent>
                        <DialogActions style={{display:'flex', alignItems:'center', justifyContent:'center', marginBottom:'1rem'}}> 
                        </DialogActions>
            </Dialog>  

            </Page>
        )
    }
}